import ICSTextInput from '../../components/ICSTextInput/ICSTextInput'
import ICSButton from '../../components/ICS/Button/ICSButton'
import { Row, Col, Form, FormGroup } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import Joi from 'joi'
import { joiResolver } from '@hookform/resolvers/joi'
import ICSErrorCard from '../../components/ICSErrorCard/ICSErrorCard'
import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { resetPassword } from '../../redux/slices'
import { DefaultState } from '../../types'
import './LostPassword.css'

const defaultJoiSchema = {
  username: Joi.string().required().messages({
    'any.required': `Username is required`,
  }),
}

const schema = Joi.object(defaultJoiSchema)

const LostPasswordForm = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const accounts = useSelector((state: DefaultState) => state.accounts)
  const {
    formState: { errors, isSubmitted, isValid },
    handleSubmit,
    control,
    setError,
    getValues,
  } = useForm({
    mode: 'onChange',
    resolver: joiResolver(schema),
  })

  const onSubmit = useCallback(() => {
    const { username } = getValues()
    dispatch(resetPassword(username))
  }, [])

  const handleClick = () => {
    navigate('/ui2/login')
  }

  return (
    <div id='form_container'>
      <Row>
        <Col xs={{ size: 12 }}>
          {errors?.code === 'error' && (
            <ICSErrorCard
              code={errors.code}
              message={errors.message}
              fields={errors.fields}
            />
          )}
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Row>
                <Col>
                  <ICSTextInput
                    label='Username'
                    name='username'
                    isSubmitted
                    errors={errors}
                    control={control}
                    setError={setError}
                    id='username-input'
                  />
                </Col>
              </Row>
              <Row className='reset-btn-row'>
                <ICSButton
                  id='form_submit'
                  width={60}
                  useSubmitBehavior={true}
                  type='success'
                  disabled={!isValid || errors.code === 'error'}
                  className='visible'
                >
                  Reset
                </ICSButton>
                <ICSButton
                  id='form_cancel'
                  width={60}
                  type='back'
                  onClick={handleClick}
                  useSubmitBehavior={false}
                >
                  Back
                </ICSButton>
              </Row>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </div>
  )
}

export default LostPasswordForm
